import { getUrl } from "./service-utils";

const getCalendarURL = (
    clientId: string | undefined,
    parameters?: string | undefined,
) => {

    return getUrl("calendar", clientId, parameters)
}

/**
 * Get a url to subscribe to a calendar
 * @param authToken - Bearer token for authentication 
 * @param user - The user to fetch the subscription url
 * @param clientId - The id for the client partition
 * @returns Promise resolving to subscription url
 */
export const getSubscribeUrl = async (
    authToken: string,
    userId: string,
    clientId?: string,
): Promise<{
    url: string
}> => {

    let url = getCalendarURL(clientId, `${userId}/generate`)

    let jsonUrl = ""

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
        });

        const json = await response.json();
        jsonUrl = json?.url

    } catch (error) {
        console.log(error);
        throw error as Error;
    }

    return {
        url: jsonUrl
    }
};